import { ResourceOptions } from 'react-admin';
import { FaBroadcastTower } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxWinnersTicker;
export const icon = FaBroadcastTower;
export const options: ResourceOptions = {
  label: 'module.blindBox.winnersTicker',
};
